import React, { useCallback, useEffect, useState } from "react";
import { Badge, Button, Col, DatePicker, Row, Select } from "antd";
import { getListSetExamAPI } from "api/ismsApi";
import "./ViewExam.css";
import {
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  setIsCheckOpenModal,
  setDataExam,
  setDataExamDetail,
  setValueTypeQuestion,
  setSelectedYear,
  setQuestionType,
  setIsCheckFilter,
} from "app/Reducers/examSlice";
import { useDispatch, useSelector } from "react-redux";
import ViemUpdateExam from "./ModalExam/ViemUpdateExam";
import { GetTypeQuestionApi } from "api/getQuiz";
import moment from "moment";
import { BsFillSquareFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const ViewExam = () => {
  const dispatch = useDispatch();
  const {
    dataExam,
    valueTypeQuestion,
    selectedYear,
    questionType,
    isCheckFilter,
  } = useSelector((state) => state.exam);

  const [selectedCard, setSelectedCard] = useState(null);

  const fetchDataSetExam = useCallback(
    (params = {}) => {
      getListSetExamAPI(params)
        .then((res) => {
          dispatch(setDataExam(res.data.results));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [dispatch]
  );

  const fetchDataTypeQuestion = useCallback(
    (params = {}) => {
      GetTypeQuestionApi(params)
        .then((res) => {
          dispatch(setValueTypeQuestion(res.data.results));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [dispatch]
  );

  useEffect(() => {
    fetchDataSetExam();
    fetchDataTypeQuestion();
  }, [fetchDataSetExam, fetchDataTypeQuestion]);

  const handleClickAddExam = () => {
    dispatch(setIsCheckOpenModal(true));
  };

  const handleClickCard = (e) => {
    dispatch(setIsCheckOpenModal(true));
    dispatch(setDataExamDetail(e));
    setSelectedCard(e.ma_de_thi); // hoặc item.id nếu có
  };

  const handleClickFilter = () => {
    dispatch(setIsCheckFilter());
  };

  const onChangeYear = (date) => {
    const year = date?.year(); // lấy năm dạng số nguyên
    dispatch(setSelectedYear(year));
  };

  const onChangeQuestionType = (e) => {
    dispatch(setQuestionType(e));
  };

  const handleClickSearch = () => {
    fetchDataSetExam({ loai_cau_hoi: questionType, year: selectedYear });
  };

  const returnActive = (e) => {
    // const time_now_system = "2025-07-06T12:34:32.929820";
    // const ngay_ket_thuc = "06/07/2025";
    const [day, month, year] = e.ngay_ket_thuc.split("/");
    const endDate = new Date(`${year}-${month}-${day}T23:59:59`); // đặt giờ cuối ngày
    const now = new Date(e.time_now_system);
    const isBeforeOrEqual = now <= endDate;
    if (isBeforeOrEqual) {
      return "card card-active";
    } else {
      return "card card-deactive";
    }
  };
  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Đợt thi</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">ISMS</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Đợt thi</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/isms/exam">Tạo đợt thi</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <Row style={{ marginBottom: 20 }}>
        <Col>
          <DatePicker
            onChange={onChangeYear}
            picker="year"
            placeholder="Chọn năm"
            style={{ borderRadius: 10 }}
            value={selectedYear ? moment().year(selectedYear) : moment()}
            allowClear={false}
          />
          <Select
            style={{ width: 150, marginLeft: 20 }}
            placeholder="Chọn nhóm thi"
            onChange={onChangeQuestionType}
            allowClear
          >
            {valueTypeQuestion.map((item, index) => (
              <Select.Option key={item.id} value={item.id}>
                {item.note}
              </Select.Option>
            ))}
          </Select>

          <Button
            type="primary"
            shape="circle"
            icon={<SearchOutlined />}
            style={{ marginLeft: 20 }}
            onClick={handleClickSearch}
            className="button-save-filter"
            size="small"
          />
        </Col>
        <Col>
          <Button
            icon={<PlusOutlined />}
            ghost
            type="success"
            onClick={handleClickAddExam}
            style={{ marginLeft: 20 }}
          >
            Thêm mới
          </Button>
        </Col>
        <Col style={{ marginLeft: "auto", textAlign: "right" }}>
          <Badge>
            <BsFillSquareFill
              className="styleBorder_1 timekeeper-detail-note"
              style={{ color: "#cdd0d5", border: "1px solid #94a0ad" }}
            />
            Đợt thi hết hạn
          </Badge>
          <Badge>
            <BsFillSquareFill
              className="styleBorder_1 timekeeper-detail-note"
              style={{ color: "#e6f7ff", border: "1px solid #91d5ff" }}
            />
            Đợt thi còn hạn
          </Badge>
        </Col>
      </Row>

      <div className="card-container">
        {dataExam.map((e, index) => (
          <div
            className={returnActive(e)}
            key={index}
            onClick={() => handleClickCard(e)}
          >
            <div className="ma_de_thi">{e.ma_de_thi}</div>
            <div className="date" title="Nhóm thi">
              📘 {e.loai_cau_hoi.note}
            </div>
            <div className="date" title="Hạn thi">
              ⏳ {e.ngay_bat_dau} - {e.ngay_ket_thuc}
            </div>
          </div>
        ))}
      </div>
      <ViemUpdateExam fetchDataSetExam={fetchDataSetExam} />
    </div>
  );
};

export default ViewExam;
